import { render, staticRenderFns } from "./_pinnedPosts.vue?vue&type=template&id=172be8c6&scoped=true"
import script from "./_pinnedPosts.vue?vue&type=script&lang=js"
export * from "./_pinnedPosts.vue?vue&type=script&lang=js"
import style0 from "./_pinnedPosts.vue?vue&type=style&index=0&id=172be8c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172be8c6",
  null
  
)

export default component.exports